export default __webpack_public_path__ + "static/media/icon-trash-circle-outline.d77c88d9.svg";